import { Layout } from 'antd'
import { StyledGlobalLayout } from 'components/GlobalStyles'
import PageFooter from 'components/PageFooter'
import PageHeader from 'components/PageHeader'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const { Content } = Layout

const StyledBanner = styled.div`
  background-image: url('/images/about-us/about-banner.png');
  background-size: cover;
  background-position: center;
  height: 450px;
  margin-top: -25px;

  @media only screen and (max-width: 768px) {
    background-size: fit;
    height: 300px;
    margin-top: none;
  }
`

const StyledContent = styled(Content)``

export default function Index ({ children }) {
  return (
    <StyledGlobalLayout bg='/images/bg/standard-bg.png'>
      <PageHeader />
      <StyledBanner />
      <StyledContent>{children({})}</StyledContent>
      <PageFooter />
    </StyledGlobalLayout>
  )
}

Index.propTypes = {
  children: PropTypes.any
}
